import React, { Component } from "react";
import { Modal, Form, Row, Col, Input, Select, InputNumber, message } from "antd";
import { connect } from "react-redux";
import * as actionCreators from "./../../actions/knowledge";
const { Option } = Select;

class FormKnowledge extends Component {
    state = {
        loading: false,
    };

    handleResponse = (response) => {
        this.setState({ loading: false });
        if (response) {
            message.success("Guardado com sucesso");
            this.props.handleOk();
        } else message.error("Ocorreu um erro");
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                if (this.props.isEdit) {
                    values.id_conhecimento = this.props.formKnowledge.id_conhecimento;
                    this.props.update({ formulario: this.props.formulario, values }).then((response) => {
                        this.handleResponse(response);
                    });
                } else {
                    this.props.insert({ formulario: this.props.formulario, values }).then((response) => {
                        this.handleResponse(response);
                    });
                }
            }
        });
    };

    render() {
        const title = this.props.isEdit ? "Editar conhecimento" : "Novo conhecimento";
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title={title}
                visible={this.props.isVisible}
                onOk={this.handleOk}
                onCancel={this.props.handleCancel}
                width="50%"
                confirmLoading={this.state.loading}
            >
                <Form layout="vertical" onSubmit={this.props.handleOk}>
                    <Row gutter={18}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Tipo de conhecimento">
                                {getFieldDecorator("tipo_conhecimento", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        allowClear
                                        // style={{ width: 200 }}
                                        onChange={this.handleTipoChange}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {this.props.tipoConhecimento.map((tipo) => (
                                            <Option key={tipo.id_tipo_conhecimento}>{tipo.designacao}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Conhecimento">
                                {getFieldDecorator("designacao", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<Input style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Inc. Nega.">
                                {getFieldDecorator("n_inc_cri_neg")(<InputNumber min={0} style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Inc. Posi.">
                                {getFieldDecorator("n_inc_cri_posi")(<InputNumber min={0} style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Sugestões">
                                {getFieldDecorator("n_sugests")(<InputNumber min={0} style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    setField: actionCreators.setField,
    insert: actionCreators.insert,
    update: actionCreators.update,
};

const mapStateToProps = (state, ownProps) => {
    return {
        formKnowledge: ownProps.isEdit ? state.knowledge.domain.formEdit : state.knowledge.domain.formCreate,
        formulario: state.knowledge.domain.metadata.formulario,
        tipoConhecimento: Object.values(state.knowledgeType.domain.byId),
    };
};

const formCreate = Form.create({
    mapPropsToFields(props) {
        return {
            tipo_conhecimento: Form.createFormField({
                ...props.formKnowledge.tipo_conhecimento,
                value: props.formKnowledge.tipo_conhecimento.value,
            }),
            designacao: Form.createFormField({
                ...props.formKnowledge.designacao,
                value: props.formKnowledge.designacao.value,
            }),
            n_inc_cri_neg: Form.createFormField({
                ...props.formKnowledge.n_inc_cri_neg,
                value: props.formKnowledge.n_inc_cri_neg.value,
            }),
            n_inc_cri_posi: Form.createFormField({
                ...props.formKnowledge.n_inc_cri_posi,
                value: props.formKnowledge.n_inc_cri_posi.value,
            }),
            n_sugests: Form.createFormField({
                ...props.formKnowledge.n_sugests,
                value: props.formKnowledge.n_sugests.value,
            }),
        };
    },
    onFieldsChange(props, fields) {
        props.setField({ isEdit: props.isEdit, fields });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(formCreate(FormKnowledge));
